export const customCssStyles = {
    alergensCollapseContainer: {
        '& .MuiCollapse-wrapper': {
            display: 'block',
        },
    },
    alergensCointainer: {
        padding: 10,
        paddingTop: 15,
    },
    alergensListItem: {
        padding: 0,
        // paddingBottom: 0,
    },
    alergenIcon: {
        width: 25,
        marginRight: 20
    },

    oldPrice: {
        fontWeight: 'normal !important'
    },

    // Applied to the product Card when the `equal_height_products` setting is on.
    // Makes every product in a row as tall as the tallest one (driven by the longest
    // description), and pins the variants/price block to the bottom so they align.
    // The card already fills the grid cell (height 100% + Grid row stretch); the inner
    // wrapper div (CardContent + variants, which has no data-class) grows to fill it.
    equalHeightProductCard: {
        height: '100%',
        '& > div:not([data-class])': {
            flex: '1 1 auto',
            display: 'flex',
            flexDirection: 'column',
        },
        '& [data-class="variants-container"]': {
            marginTop: 'auto',
        },
    }
}